/* import __COLOCATED_TEMPLATE__ from './tag-user-empty-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();